/**
 * Mock data cho POC Demo – khi chuyển sang API thật thì xóa hoặc tắt VITE_USE_MOCK.
 */
import type { Case, CaseDetail, CaseEvent } from '../types/case'
import type { Filing } from '../types/filing'
import type { Document } from '../types/document'
import type { CourtSession } from '../types/session'
import type { Alert } from '../types/alert'
import type { WorkspaceTask } from '../types/workspaceTask'

export const mockCases: Case[] = [
  {
    id: 'case-1',
    case_code: 'HN-GD-2026-001',
    track: 'A',
    category: 'marriage_family',
    status: 'accepted',
    claim_value_vnd: 150000000,
    plaintiff_id: 'user-1',
    defendant_id: 'user-2',
    plaintiff_name: 'Lê Hoàng Nam',
    defendant_name: 'Nguyễn Thị Mai Linh',
    assigned_judge_id: 'judge-1',
    assigned_judge_name: 'Thẩm phán Trần Văn Bình',
    assigned_secretary_id: 'sec-1',
    secretary_name: 'Thư ký Nguyễn Thị Hương',
    filed_at: '2026-02-01T08:00:00Z',
    next_hearing_at: '2026-03-25T08:00:00Z',
    deadline_at: '2026-03-30T17:00:00Z',
    created_at: '2026-01-28T10:00:00Z',
    updated_at: '2026-02-05T14:00:00Z',
    created_by: 'user-1',
  },
  {
    id: 'case-2',
    case_code: 'HN-GD-2026-002',
    track: 'A',
    category: 'marriage_family',
    status: 'filed',
    claim_value_vnd: 80000000,
    plaintiff_id: 'user-1',
    defendant_id: 'user-3',
    plaintiff_name: 'Lê Hoàng Nam',
    defendant_name: 'Đặng Văn Hùng',
    filed_at: '2026-03-01T09:00:00Z',
    deadline_at: '2026-03-15T17:00:00Z',
    created_at: '2026-03-01T09:00:00Z',
    updated_at: '2026-03-01T09:00:00Z',
    created_by: 'user-1',
  },
  {
    id: 'case-3',
    case_code: 'HN-GD-2026-003',
    track: 'B',
    category: 'marriage_family',
    status: 'pre_trial',
    claim_value_vnd: 250000000,
    plaintiff_id: 'user-2',
    defendant_id: 'user-1',
    plaintiff_name: 'Nguyễn Thị Mai Linh',
    defendant_name: 'Lê Hoàng Nam',
    assigned_judge_id: 'judge-1',
    assigned_judge_name: 'Thẩm phán Trần Văn Bình',
    assigned_secretary_id: 'sec-1',
    secretary_name: 'Thư ký Nguyễn Thị Hương',
    filed_at: '2026-02-15T00:00:00Z',
    next_hearing_at: '2026-03-20T08:00:00Z',
    deadline_at: '2026-04-01T17:00:00Z',
    created_at: '2026-02-10T00:00:00Z',
    updated_at: '2026-03-10T00:00:00Z',
    created_by: 'user-2',
  },
  {
    id: 'case-4',
    case_code: 'DS-2026-004',
    track: 'C',
    category: 'civil',
    status: 'trial',
    claim_value_vnd: 1200000000,
    plaintiff_id: 'user-3',
    defendant_id: 'user-1',
    plaintiff_name: 'Phạm Quốc Bảo',
    defendant_name: 'Lê Hoàng Nam',
    assigned_judge_id: 'judge-1',
    assigned_judge_name: 'Thẩm phán Trần Văn Bình',
    assigned_secretary_id: 'sec-1',
    secretary_name: 'Thư ký Nguyễn Thị Hương',
    filed_at: '2026-01-10T08:00:00Z',
    next_hearing_at: '2026-03-18T08:00:00Z',
    created_at: '2026-01-05T10:00:00Z',
    updated_at: '2026-03-10T00:00:00Z',
    created_by: 'user-3',
  },
  {
    id: 'case-5',
    case_code: 'DD-2026-005',
    track: 'B',
    category: 'land',
    status: 'accepted',
    claim_value_vnd: 500000000,
    plaintiff_id: 'user-2',
    defendant_id: 'user-3',
    plaintiff_name: 'Nguyễn Thị Mai Linh',
    defendant_name: 'Đặng Văn Hùng',
    assigned_judge_id: 'judge-2',
    assigned_judge_name: 'Thẩm phán Lê Thị Mai',
    assigned_secretary_id: 'sec-2',
    secretary_name: 'Thư ký Trần Văn Khải',
    filed_at: '2026-03-05T09:00:00Z',
    next_hearing_at: '2026-04-10T08:00:00Z',
    deadline_at: '2026-04-20T17:00:00Z',
    created_at: '2026-03-01T10:00:00Z',
    updated_at: '2026-03-08T00:00:00Z',
    created_by: 'user-2',
  },
  {
    id: 'case-demo',
    case_code: 'HN-GD-2026-006',
    track: 'A',
    category: 'marriage_family',
    status: 'filed',
    claim_value_vnd: 50000000,
    plaintiff_id: 'demo-user',
    defendant_id: 'user-2',
    plaintiff_name: 'Phạm Thị Hồng Nhung',
    defendant_name: 'Trần Văn Đức',
    filed_at: '2026-03-10T09:00:00Z',
    created_at: '2026-03-10T09:00:00Z',
    updated_at: '2026-03-10T09:00:00Z',
    created_by: 'demo-user',
  },
  {
    id: 'case-6',
    case_code: 'DS-2026-007',
    track: 'B',
    category: 'civil',
    status: 'filed',
    claim_value_vnd: 320000000,
    plaintiff_id: 'user-1',
    defendant_id: 'user-2',
    plaintiff_name: 'Lê Hoàng Nam',
    defendant_name: 'Nguyễn Thị Mai Linh',
    filed_at: '2026-03-08T10:00:00Z',
    created_at: '2026-03-08T10:00:00Z',
    updated_at: '2026-03-08T10:00:00Z',
    created_by: 'user-1',
  },
  {
    id: 'case-7',
    case_code: 'DD-2026-008',
    track: 'A',
    category: 'land',
    status: 'accepted',
    claim_value_vnd: 680000000,
    plaintiff_id: 'user-3',
    defendant_id: 'user-1',
    plaintiff_name: 'Đặng Văn Hùng',
    defendant_name: 'Lê Hoàng Nam',
    assigned_judge_id: 'judge-2',
    assigned_judge_name: 'Thẩm phán Lê Thị Mai',
    assigned_secretary_id: 'sec-1',
    secretary_name: 'Thư ký Nguyễn Thị Hương',
    filed_at: '2026-02-20T08:00:00Z',
    next_hearing_at: '2026-04-05T08:00:00Z',
    deadline_at: '2026-04-15T17:00:00Z',
    created_at: '2026-02-18T00:00:00Z',
    updated_at: '2026-03-01T00:00:00Z',
    created_by: 'user-3',
  },
  {
    id: 'case-closed',
    case_code: 'HN-GD-2025-099',
    track: 'A',
    category: 'marriage_family',
    status: 'closed',
    claim_value_vnd: 120000000,
    plaintiff_id: 'demo-user',
    defendant_id: 'user-2',
    plaintiff_name: 'Phạm Thị Hồng Nhung',
    defendant_name: 'Trần Văn Đức',
    assigned_judge_id: 'judge-1',
    assigned_judge_name: 'Thẩm phán Trần Văn Bình',
    assigned_secretary_id: 'sec-1',
    secretary_name: 'Thư ký Nguyễn Thị Hương',
    filed_at: '2025-10-01T08:00:00Z',
    created_at: '2025-09-28T10:00:00Z',
    updated_at: '2026-01-15T14:00:00Z',
    created_by: 'demo-user',
  },
]

/** case-1: đã thụ lý, đã phân công, có phiên kiểm tra chứng cứ. Thứ tự: Nộp đơn → Thụ lý → Phân công → Phiên kiểm tra. */
const case1Timeline: CaseEvent[] = [
  { id: 'ev-1', type: 'filed', title: 'Nộp đơn khởi kiện', at: '2026-01-28T10:00:00Z', user_name: 'Hệ thống', description: 'Nguyên đơn nộp đơn qua Cổng dịch vụ công. Tòa tiếp nhận và chuyển Thư ký kiểm tra hình thức.' },
  { id: 'ev-2', type: 'accepted', title: 'Thụ lý vụ án', at: '2026-02-01T08:00:00Z', user_name: 'Thư ký Nguyễn Thị Hương', description: 'Tòa ra quyết định thụ lý. Thông báo thụ lý và giấy báo nộp tạm ứng án phí đã gửi các bên.' },
  { id: 'ev-3', type: 'assigned', title: 'Phân công Thẩm phán', at: '2026-02-03T09:00:00Z', user_name: 'Chánh án Lê Văn Cường' },
  { id: 'ev-4', type: 'session', title: 'Phiên họp kiểm tra chứng cứ', at: '2026-03-15T08:00:00Z', user_name: 'Thẩm phán Trần Văn Bình' },
]

export const mockCaseDetails: Record<string, CaseDetail> = {
  'case-demo': {
    ...mockCases[mockCases.length - 1],
    plaintiff_name: 'Phạm Thị Hồng Nhung',
    defendant_name: 'Trần Văn Đức',
    timeline: [
      { id: 'ev-d1', type: 'filed', title: 'Đơn đã nộp', at: '2026-03-10T09:00:00Z', user_name: 'Hệ thống', description: 'Đơn khởi kiện ly hôn đã được Tòa án tiếp nhận qua Cổng dịch vụ công. Đang chờ Thư ký kiểm tra hình thức và thông báo kết quả.' },
    ],
  },
  'case-1': {
    ...mockCases[0],
    plaintiff_name: 'Lê Hoàng Nam',
    defendant_name: 'Nguyễn Thị Mai Linh',
    assigned_judge_name: 'Thẩm phán Trần Văn Bình',
    timeline: case1Timeline,
  },
  'case-2': {
    ...mockCases[1],
    plaintiff_name: 'Lê Hoàng Nam',
    defendant_name: 'Đặng Văn Hùng',
    timeline: [
      { id: 'ev-2a', type: 'filed', title: 'Nộp đơn khởi kiện', at: '2026-03-01T09:00:00Z', user_name: 'Hệ thống' },
    ],
  },
  'case-3': {
    ...mockCases[2],
    plaintiff_name: 'Nguyễn Thị Mai Linh',
    defendant_name: 'Lê Hoàng Nam',
    assigned_judge_name: 'Thẩm phán Trần Văn Bình',
    timeline: [
      { id: 'ev-3a', type: 'filed', title: 'Nộp đơn khởi kiện', at: '2026-02-10T09:00:00Z', user_name: 'Hệ thống' },
      { id: 'ev-3b', type: 'accepted', title: 'Thụ lý vụ án', at: '2026-02-15T00:00:00Z', user_name: 'Thư ký Nguyễn Thị Hương' },
      { id: 'ev-3c', type: 'assigned', title: 'Phân công Thẩm phán', at: '2026-02-16T00:00:00Z', user_name: 'Chánh án Lê Văn Cường' },
      { id: 'ev-3kt', type: 'session', title: 'Phiên họp kiểm tra chứng cứ', at: '2026-03-05T08:00:00Z', user_name: 'Thẩm phán Trần Văn Bình', description: 'Tổ chức phiên họp kiểm tra chứng cứ. Các bên xuất trình chứng cứ, Tòa ghi nhận và chuyển giai đoạn hòa giải.' },
      { id: 'ev-3d', type: 'session', title: 'Phiên hòa giải', at: '2026-03-20T08:00:00Z', user_name: 'Thẩm phán Trần Văn Bình', description: 'Tổ chức phiên hòa giải. Kết quả sẽ cập nhật sau phiên.' },
    ],
  },
  'case-4': {
    ...mockCases[3],
    timeline: [
      { id: 'ev-4a', type: 'filed', title: 'Nộp đơn khởi kiện', at: '2026-01-05T10:00:00Z', user_name: 'Hệ thống' },
      { id: 'ev-4b', type: 'accepted', title: 'Thụ lý vụ án', at: '2026-01-10T08:00:00Z', user_name: 'Thư ký Nguyễn Thị Hương' },
      { id: 'ev-4c', type: 'assigned', title: 'Phân công Thẩm phán', at: '2026-01-15T09:00:00Z', user_name: 'Chánh án Lê Văn Cường' },
      { id: 'ev-4kt', type: 'session', title: 'Phiên họp kiểm tra chứng cứ', at: '2026-02-10T08:00:00Z', user_name: 'Thẩm phán Trần Văn Bình', description: 'Phiên họp kiểm tra chứng cứ. Các bên xuất trình, Tòa ghi nhận.' },
      { id: 'ev-4hg', type: 'session', title: 'Phiên hòa giải', at: '2026-02-28T08:00:00Z', user_name: 'Thẩm phán Trần Văn Bình', description: 'Tổ chức phiên hòa giải. Hai bên không thỏa thuận được, Tòa đưa vụ án ra xét xử.' },
      { id: 'ev-4d', type: 'session', title: 'Phiên xét xử sơ thẩm', at: '2026-03-18T08:00:00Z', user_name: 'Thẩm phán Trần Văn Bình', description: 'Phiên xét xử trực tuyến theo lịch.' },
    ],
  },
  'case-5': {
    ...mockCases[4],
    timeline: [
      { id: 'ev-5nop', type: 'filed', title: 'Nộp đơn khởi kiện', at: '2026-03-01T09:00:00Z', user_name: 'Hệ thống' },
      { id: 'ev-5a', type: 'accepted', title: 'Thụ lý vụ án', at: '2026-03-05T09:00:00Z', user_name: 'Thư ký Trần Văn Khải', description: 'Tòa đã thụ lý. Chờ Chánh án phân công Thẩm phán.' },
    ],
  },
  'case-6': {
    ...mockCases.find((c) => c.id === 'case-6')!,
    plaintiff_name: 'Lê Hoàng Nam',
    defendant_name: 'Nguyễn Thị Mai Linh',
    timeline: [
      { id: 'ev-6a', type: 'filed', title: 'Nộp đơn khởi kiện', at: '2026-03-08T10:00:00Z', user_name: 'Hệ thống' },
    ],
  },
  'case-7': {
    ...mockCases.find((c) => c.id === 'case-7')!,
    plaintiff_name: 'Đặng Văn Hùng',
    defendant_name: 'Lê Hoàng Nam',
    assigned_judge_name: 'Thẩm phán Lê Thị Mai',
    timeline: [
      { id: 'ev-7nop', type: 'filed', title: 'Nộp đơn khởi kiện', at: '2026-02-18T10:00:00Z', user_name: 'Hệ thống' },
      { id: 'ev-7a', type: 'accepted', title: 'Thụ lý vụ án', at: '2026-02-20T08:00:00Z', user_name: 'Thư ký Nguyễn Thị Hương' },
      { id: 'ev-7b', type: 'assigned', title: 'Phân công Thẩm phán Lê Thị Mai', at: '2026-03-01T00:00:00Z', user_name: 'Chánh án', description: 'Chánh án phân công Thẩm phán giải quyết vụ án.' },
    ],
  },
  'case-closed': {
    ...mockCases.find((c) => c.id === 'case-closed')!,
    plaintiff_name: 'Phạm Thị Hồng Nhung',
    defendant_name: 'Trần Văn Đức',
    assigned_judge_name: 'Thẩm phán Trần Văn Bình',
    timeline: [
      { id: 'ev-c1', type: 'filed', title: 'Nộp đơn khởi kiện', at: '2025-09-28T10:00:00Z', user_name: 'Hệ thống', description: 'Nguyên đơn Phạm Thị Hồng Nhung nộp đơn yêu cầu giải quyết ly hôn qua Cổng dịch vụ công Tòa án điện tử.' },
      { id: 'ev-c2', type: 'accepted', title: 'Thụ lý vụ án', at: '2025-10-01T08:00:00Z', user_name: 'Thư ký Nguyễn Thị Hương', description: 'Tòa án nhân dân quận 1 ra quyết định thụ lý vụ án. Thông báo thụ lý và Giấy báo nộp tạm ứng án phí đã được gửi đến các bên.' },
      { id: 'ev-c3', type: 'accepted', title: 'Nguyên đơn nộp tạm ứng án phí', at: '2025-10-15T00:00:00Z', user_name: 'Hệ thống', description: 'Nguyên đơn đã nộp tạm ứng án phí theo Giấy báo. Hồ sơ đủ điều kiện chuyển giai đoạn chuẩn bị xét xử.' },
      { id: 'ev-c4', type: 'assigned', title: 'Phân công Thẩm phán', at: '2025-10-20T09:00:00Z', user_name: 'Chánh án Lê Văn Cường', description: 'Chánh án phân công Thẩm phán Trần Văn Bình giải quyết vụ án.' },
      { id: 'ev-c5', type: 'session', title: 'Phiên hòa giải', at: '2025-11-18T08:00:00Z', user_name: 'Thẩm phán Trần Văn Bình', description: 'Tổ chức phiên hòa giải. Hai bên không thỏa thuận được, Tòa đưa vụ án ra xét xử.' },
      { id: 'ev-c6', type: 'session', title: 'Phiên xét xử sơ thẩm', at: '2025-12-10T08:00:00Z', user_name: 'Thẩm phán Trần Văn Bình', description: 'Phiên xét xử trực tuyến. HĐXX đã xét hỏi, tranh tụng; các bên trình bày ý kiến. HĐXX nghị án.' },
      { id: 'ev-c7', type: 'decision', title: 'Tuyên án', at: '2026-01-15T10:00:00Z', user_name: 'Thẩm phán Trần Văn Bình', description: 'Tòa tuyên án tại phiên. Chấp nhận đơn của nguyên đơn. Quyết định về ly hôn, nuôi con chung, phân chia tài sản theo nội dung bản án.' },
      { id: 'ev-c8', type: 'closed', title: 'Bản án được gửi đương sự', at: '2026-01-15T14:00:00Z', user_name: 'Thư ký Nguyễn Thị Hương', description: 'Bản án sơ thẩm số 01/2026/HNGD-ST đã được tống đạt đến các bên. Thời hạn kháng cáo: 15 ngày kể từ ngày nhận được bản án.' },
    ],
  },
}

export const mockFilings: Filing[] = [
  {
    id: 'filing-1',
    case_id: 'case-1',
    type: 'complaint',
    filer_id: 'user-1',
    status: 'accepted',
    form_data: { subject: 'Yêu cầu giải quyết ly hôn', reason: 'Hai bên bất đồng, không thể tiếp tục duy trì hôn nhân.' },
    submitted_at: '2026-01-28T10:00:00Z',
    created_at: '2026-01-28T10:00:00Z',
    updated_at: '2026-02-02T10:00:00Z',
  },
  {
    id: 'filing-2',
    case_id: 'case-2',
    type: 'complaint',
    filer_id: 'user-1',
    status: 'submitted',
    form_data: { subject: 'Tranh chấp tài sản chung', reason: 'Yêu cầu Tòa án phân chia tài sản chung theo quy định pháp luật.' },
    submitted_at: '2026-03-01T09:00:00Z',
    created_at: '2026-03-01T09:00:00Z',
    updated_at: '2026-03-01T09:00:00Z',
  },
  {
    id: 'filing-closed',
    case_id: 'case-closed',
    type: 'complaint',
    filer_id: 'demo-user',
    status: 'accepted',
    form_data: {
      subject: 'Yêu cầu giải quyết ly hôn',
      reason: 'Hai bên không thể tiếp tục duy trì hôn nhân, đã thỏa thuận về con chung và tài sản. Kính đề nghị Tòa án xem xét giải quyết.',
      dispute_type: 'ly_hon',
      defendant_name: 'Trần Văn Đức',
    },
    submitted_at: '2025-09-28T10:00:00Z',
    created_at: '2025-09-28T10:00:00Z',
    updated_at: '2025-10-01T08:00:00Z',
  },
]

export const mockDocuments: Document[] = [
  {
    id: 'doc-1',
    case_id: 'case-1',
    type: 'notice_acceptance',
    title: 'Thông báo thụ lý vụ án dân sự',
    content: 'Tòa án nhân dân quận 1 thông báo đã thụ lý vụ án HN-GD-2026-001 theo đơn khởi kiện của ông Lê Hoàng Nam. Các bên vui lòng nộp tạm ứng án phí trong thời hạn 15 ngày theo quy định.',
    status: 'sent',
    author_id: 'sec-1',
    created_at: '2026-02-01T08:30:00Z',
    updated_at: '2026-02-01T08:30:00Z',
  },
  {
    id: 'doc-2',
    case_id: 'case-1',
    type: 'summons',
    title: 'Giấy triệu tập tham gia phiên họp kiểm tra chứng cứ',
    content: 'Tòa án nhân dân quận 1 triệu tập nguyên đơn, bị đơn tham gia phiên họp kiểm tra chứng cứ vào 08h00 ngày 15/03/2026. Địa điểm: Phòng xử án số 3. Các bên mang theo CMND/CCCD và chứng cứ gốc.',
    status: 'draft',
    author_id: 'judge-1',
    created_at: '2026-03-01T00:00:00Z',
    updated_at: '2026-03-01T00:00:00Z',
  },
  {
    id: 'doc-3',
    case_id: 'case-1',
    type: 'fee_notice',
    title: 'Giấy báo nộp tạm ứng án phí',
    content: 'Tòa án nhân dân quận 1 thông báo nguyên đơn Lê Hoàng Nam nộp tạm ứng án phí theo quy định trong thời hạn 15 ngày kể từ ngày nhận thông báo này.',
    status: 'sent',
    author_id: 'sec-1',
    created_at: '2026-02-03T09:00:00Z',
    updated_at: '2026-02-03T09:00:00Z',
  },
  {
    id: 'doc-closed-1',
    case_id: 'case-closed',
    type: 'notice_acceptance',
    title: 'Thông báo thụ lý vụ án',
    content: 'TÒA ÁN NHÂN DÂN QUẬN 1\n\nTHÔNG BÁO THỤ LÝ VỤ ÁN\nSố: 01/2025/TB-TLST – Ngày 01/10/2025\n\nKính gửi: Bà Phạm Thị Hồng Nhung (Nguyên đơn), Ông Trần Văn Đức (Bị đơn).\n\nVề việc: Yêu cầu giải quyết ly hôn – Vụ án HN-GD-2025-099.\n\nTòa án nhân dân quận 1 thông báo đã thụ lý vụ án theo đơn khởi kiện của bà Phạm Thị Hồng Nhung. Các bên vui lòng nộp tạm ứng án phí trong thời hạn 15 ngày làm việc kể từ ngày nhận thông báo này theo quy định tại Điều 147 Bộ luật Tố tụng dân sự.',
    status: 'sent',
    author_id: 'sec-1',
    created_at: '2025-10-01T08:30:00Z',
    updated_at: '2025-10-01T08:30:00Z',
  },
  {
    id: 'doc-closed-2',
    case_id: 'case-closed',
    type: 'fee_notice',
    title: 'Giấy báo nộp tạm ứng án phí',
    content: 'TÒA ÁN NHÂN DÂN QUẬN 1\n\nGIẤY BÁO NỘP TẠM ỨNG ÁN PHÍ\nSố: 02/2025/TB-AP – Ngày 01/10/2025\n\nKính gửi: Bà Phạm Thị Hồng Nhung (Nguyên đơn).\n\nVụ án: HN-GD-2025-099 – Yêu cầu giải quyết ly hôn.\n\nNguyên đơn nộp tạm ứng án phí theo quy định trong thời hạn 15 ngày làm việc. Số tiền và tài khoản được ghi tại phiếu thu kèm theo. Sau khi nộp, vui lòng xác nhận qua hệ thống hoặc gửi biên lai về Tòa án.',
    status: 'sent',
    author_id: 'sec-1',
    created_at: '2025-10-01T09:00:00Z',
    updated_at: '2025-10-01T09:00:00Z',
  },
  {
    id: 'doc-closed-3',
    case_id: 'case-closed',
    type: 'summons',
    title: 'Giấy triệu tập tham gia phiên hòa giải',
    content: 'TÒA ÁN NHÂN DÂN QUẬN 1\n\nGIẤY TRIỆU TẬP\nSố: 03/2025/GT – Ngày 05/11/2025\n\nKính gửi: Bà Phạm Thị Hồng Nhung, Ông Trần Văn Đức.\n\nVụ án: HN-GD-2025-099 – Yêu cầu giải quyết ly hôn.\n\nTòa án triệu tập các bên tham gia phiên hòa giải vào 08h00 ngày 18/11/2025 tại Phòng xử án số 3 (hoặc qua hình thức trực tuyến theo link sẽ gửi sau). Các bên mang theo CMND/CCCD, Giấy chứng nhận kết hôn và các chứng cứ liên quan.',
    status: 'sent',
    author_id: 'judge-1',
    created_at: '2025-11-05T00:00:00Z',
    updated_at: '2025-11-05T00:00:00Z',
  },
  {
    id: 'doc-closed-4',
    case_id: 'case-closed',
    type: 'summons',
    title: 'Giấy triệu tập tham gia phiên xét xử',
    content: 'TÒA ÁN NHÂN DÂN QUẬN 1\n\nGIẤY TRIỆU TẬP\nSố: 04/2025/GT – Ngày 25/11/2025\n\nKính gửi: Bà Phạm Thị Hồng Nhung, Ông Trần Văn Đức.\n\nVụ án: HN-GD-2025-099 – Yêu cầu giải quyết ly hôn.\n\nSau phiên hòa giải, các bên không thỏa thuận được. Tòa án triệu tập các bên tham gia phiên xét xử sơ thẩm vào 08h00 ngày 10/12/2025 (trực tuyến). Link phiên họp và hướng dẫn tham gia sẽ được gửi qua hệ thống.',
    status: 'sent',
    author_id: 'judge-1',
    created_at: '2025-11-25T00:00:00Z',
    updated_at: '2025-11-25T00:00:00Z',
  },
  {
    id: 'doc-verdict-1',
    case_id: 'case-closed',
    type: 'trial_decision',
    title: 'Bản án sơ thẩm số 01/2026/HNGD-ST',
    content: `BẢN ÁN SƠ THẨM
Vụ án: Yêu cầu giải quyết ly hôn
Số: 01/2026/HNGD-ST – Ngày 15/01/2026

TÒA ÁN NHÂN DÂN QUẬN 1 – THÀNH PHỐ HỒ CHÍ MINH

Nguyên đơn: Bà Phạm Thị Hồng Nhung (có mặt)
Bị đơn: Ông Trần Văn Đức (có mặt)
Thẩm phán: Thẩm phán Trần Văn Bình
Thư ký phiên tòa: Thư ký Nguyễn Thị Hương

I. TÓM TẮT VỤ ÁN
Nguyên đơn yêu cầu Tòa án giải quyết ly hôn với bị đơn; hai bên đã thỏa thuận về con chung (một con do nguyên đơn trực tiếp nuôi dưỡng, bị đơn cấp dưỡng 2.000.000 đồng/tháng) và về việc phân chia tài sản chung (nhà ở, xe máy, tiền tiết kiệm theo tỷ lệ đã thỏa thuận).

II. NHẬN ĐỊNH CỦA TÒA ÁN
Căn cứ hồ sơ, biên bản phiên tòa và ý kiến của Kiểm sát viên, HĐXX nhận định: Đơn của nguyên đơn có cơ sở; hai bên tự nguyện thỏa thuận về con và tài sản, phù hợp pháp luật.

III. QUYẾT ĐỊNH
1. Chấp nhận đơn của nguyên đơn. Cho ly hôn giữa bà Phạm Thị Hồng Nhung và ông Trần Văn Đức.
2. Về con chung: Giao con cho bà Phạm Thị Hồng Nhung trực tiếp nuôi. Ông Trần Văn Đức có nghĩa vụ cấp dưỡng 2.000.000 đồng/tháng cho đến khi con đủ 18 tuổi.
3. Về tài sản chung: Phân chia theo thỏa thuận đã ghi trong biên bản phiên tòa.

Các bên có quyền kháng cáo bản án trong thời hạn 15 ngày kể từ ngày tuyên án (người không tham gia phiên tính từ ngày nhận được bản án).`,
    status: 'sent',
    author_id: 'judge-1',
    created_at: '2026-01-15T14:00:00Z',
    updated_at: '2026-01-15T14:00:00Z',
  },
]

export const mockSessions: CourtSession[] = [
  {
    id: 'session-1',
    case_id: 'case-1',
    case_code: 'HN-GD-2026-001',
    session_type: 'pre_trial',
    scheduled_at: '2026-03-10T08:00:00+07:00',
    meet_url: 'https://meet.google.com/abc-defg-hij',
    presiding_judge_id: 'judge-1',
    presiding_judge_name: 'Thẩm phán Trần Văn Bình',
    status: 'scheduled',
    created_at: '2026-03-01T00:00:00Z',
    updated_at: '2026-03-01T00:00:00Z',
  },
  {
    id: 'session-2',
    case_id: 'case-3',
    case_code: 'HN-GD-2026-003',
    session_type: 'mediation',
    scheduled_at: '2026-03-11T09:30:00+07:00',
    meet_url: 'https://meet.google.com/xyz-uvwx-rst',
    presiding_judge_id: 'judge-1',
    presiding_judge_name: 'Thẩm phán Trần Văn Bình',
    status: 'scheduled',
    created_at: '2026-03-05T00:00:00Z',
    updated_at: '2026-03-05T00:00:00Z',
  },
  {
    id: 'session-3',
    case_id: 'case-4',
    case_code: 'DS-2026-004',
    session_type: 'trial',
    scheduled_at: '2026-03-12T08:00:00+07:00',
    meet_url: 'https://meet.google.com/ds-2026-004',
    presiding_judge_id: 'judge-1',
    presiding_judge_name: 'Thẩm phán Trần Văn Bình',
    status: 'scheduled',
    created_at: '2026-03-02T00:00:00Z',
    updated_at: '2026-03-02T00:00:00Z',
  },
  {
    id: 'session-4',
    case_id: 'case-1',
    case_code: 'HN-GD-2026-001',
    session_type: 'pre_trial',
    scheduled_at: '2026-03-12T14:00:00+07:00',
    presiding_judge_id: 'judge-1',
    presiding_judge_name: 'Thẩm phán Trần Văn Bình',
    status: 'scheduled',
    created_at: '2026-03-08T00:00:00Z',
    updated_at: '2026-03-08T00:00:00Z',
  },
  {
    id: 'session-5',
    case_id: 'case-5',
    case_code: 'DD-2026-005',
    session_type: 'mediation',
    scheduled_at: '2026-03-13T08:00:00+07:00',
    presiding_judge_id: 'judge-2',
    presiding_judge_name: 'Thẩm phán Lê Thị Mai',
    status: 'scheduled',
    created_at: '2026-03-06T00:00:00Z',
    updated_at: '2026-03-06T00:00:00Z',
  },
  {
    id: 'session-6',
    case_id: 'case-demo',
    case_code: 'HN-GD-2026-006',
    session_type: 'pre_trial',
    scheduled_at: '2026-03-13T10:00:00+07:00',
    meet_url: 'https://meet.google.com/hn-gd-006',
    presiding_judge_id: 'judge-1',
    presiding_judge_name: 'Thẩm phán Trần Văn Bình',
    status: 'scheduled',
    created_at: '2026-03-07T00:00:00Z',
    updated_at: '2026-03-07T00:00:00Z',
  },
  {
    id: 'session-7',
    case_id: 'case-3',
    case_code: 'HN-GD-2026-003',
    session_type: 'trial',
    scheduled_at: '2026-03-14T08:00:00+07:00',
    meet_url: 'https://meet.google.com/hn-gd-003-trial',
    presiding_judge_id: 'judge-1',
    presiding_judge_name: 'Thẩm phán Trần Văn Bình',
    status: 'scheduled',
    created_at: '2026-03-09T00:00:00Z',
    updated_at: '2026-03-09T00:00:00Z',
  },
  {
    id: 'session-8',
    case_id: 'case-4',
    case_code: 'DS-2026-004',
    session_type: 'pre_trial',
    scheduled_at: '2026-03-15T08:00:00+07:00',
    meet_url: 'https://meet.google.com/abc-defg-hij',
    presiding_judge_id: 'judge-1',
    presiding_judge_name: 'Thẩm phán Trần Văn Bình',
    status: 'scheduled',
    created_at: '2026-03-01T00:00:00Z',
    updated_at: '2026-03-01T00:00:00Z',
  },
  {
    id: 'session-9',
    case_id: 'case-2',
    case_code: 'HN-GD-2026-002',
    session_type: 'mediation',
    scheduled_at: '2026-03-15T13:00:00+07:00',
    presiding_judge_id: 'judge-2',
    presiding_judge_name: 'Thẩm phán Lê Thị Mai',
    status: 'scheduled',
    created_at: '2026-03-10T00:00:00Z',
    updated_at: '2026-03-10T00:00:00Z',
  },
  {
    id: 'session-10',
    case_id: 'case-5',
    case_code: 'DD-2026-005',
    session_type: 'pre_trial',
    scheduled_at: '2026-03-16T09:00:00+07:00',
    presiding_judge_id: 'judge-2',
    presiding_judge_name: 'Thẩm phán Lê Thị Mai',
    status: 'scheduled',
    created_at: '2026-03-08T00:00:00Z',
    updated_at: '2026-03-08T00:00:00Z',
  },
  {
    id: 'session-11',
    case_id: 'case-3',
    case_code: 'HN-GD-2026-003',
    session_type: 'mediation',
    scheduled_at: '2026-03-20T08:00:00+07:00',
    presiding_judge_id: 'judge-1',
    presiding_judge_name: 'Thẩm phán Trần Văn Bình',
    status: 'scheduled',
    created_at: '2026-03-05T00:00:00Z',
    updated_at: '2026-03-05T00:00:00Z',
  },
  {
    id: 'session-12',
    case_id: 'case-1',
    case_code: 'HN-GD-2026-001',
    session_type: 'trial',
    scheduled_at: '2026-03-25T08:00:00+07:00',
    presiding_judge_id: 'judge-1',
    presiding_judge_name: 'Thẩm phán Trần Văn Bình',
    status: 'scheduled',
    created_at: '2026-03-12T00:00:00Z',
    updated_at: '2026-03-12T00:00:00Z',
  },
]

export const mockAlerts: Alert[] = [
  {
    id: 'alert-1',
    case_id: 'case-1',
    case_code: 'HN-GD-2026-001',
    type: 'session_reminder',
    title: 'Phiên họp kiểm tra chứng cứ',
    due_at: '2026-03-15T08:00:00+07:00',
    created_at: '2026-03-10T00:00:00Z',
  },
  {
    id: 'alert-2',
    case_id: 'case-2',
    case_code: 'HN-GD-2026-002',
    type: 'deadline',
    title: 'Hết hạn thông báo nộp tiền tạm ứng án phí',
    due_at: '2026-03-18T17:00:00+07:00',
    created_at: '2026-03-01T00:00:00Z',
  },
]

export const mockJudges = [
  { id: 'judge-1', name: 'Thẩm phán Trần Văn Bình', workload: 12 },
  { id: 'judge-2', name: 'Thẩm phán Lê Thị Mai', workload: 8 },
]

/** Thẩm phán cho màn hình phân công (AI gợi ý): đang giải quyết, tốc độ, chuyên môn, AI badge */
export const mockJudgesForAssign: Array<{
  id: string
  name: string
  current_cases: number
  avg_days_per_case: number
  expertise: string[]
  ai_suggestion: 'fit' | 'overload' | 'partial'
  ai_tooltip: string
}> = [
  { id: 'judge-1', name: 'Trần Văn Bình', current_cases: 15, avg_days_per_case: 18, expertise: ['Hôn nhân gia đình', 'Dân sự'], ai_suggestion: 'fit', ai_tooltip: 'Thẩm phán còn năng lực, đúng chuyên môn. Khuyến nghị phân công.' },
  { id: 'judge-2', name: 'Lê Thị Mai', current_cases: 45, avg_days_per_case: 25, expertise: ['Hôn nhân gia đình'], ai_suggestion: 'overload', ai_tooltip: 'Thẩm phán này đang xử lý 45 vụ, vượt 125% chỉ tiêu tháng. Không khuyến nghị.' },
  { id: 'judge-3', name: 'Phạm Minh Tuấn', current_cases: 28, avg_days_per_case: 20, expertise: ['Hôn nhân gia đình', 'Kinh doanh'], ai_suggestion: 'partial', ai_tooltip: 'Đúng chuyên môn nhưng tải cao vừa. Cân nhắc nếu cần.' },
]

export const mockWorkspaceTasks: WorkspaceTask[] = [
  {
    id: 'task-1',
    case_id: 'case-2',
    case_code: 'HN-GD-2026-002',
    party_name: 'Lê Hoàng Nam / Đặng Văn Hùng',
    action_type: 'filing',
    action_label: 'Kiểm tra hình thức đơn – Quyết định thụ lý/trả đơn',
    priority: 'urgent',
    due_at: '2026-03-14T17:00:00+07:00',
    created_at: '2026-03-01T09:00:00Z',
  },
  {
    id: 'task-2',
    case_id: 'case-2',
    case_code: 'HN-GD-2026-002',
    party_name: 'Lê Hoàng Nam',
    action_type: 'notice',
    action_label: 'Gửi Giấy báo nộp tạm ứng án phí',
    priority: 'urgent',
    due_at: '2026-03-13T17:00:00+07:00',
    created_at: '2026-03-02T00:00:00Z',
  },
  {
    id: 'task-3',
    case_id: 'case-1',
    case_code: 'HN-GD-2026-001',
    party_name: 'Lê Hoàng Nam / Nguyễn Thị Mai Linh',
    action_type: 'session',
    action_label: 'Phiên họp kiểm tra chứng cứ',
    priority: 'high',
    due_at: '2026-03-25T08:00:00+07:00',
    created_at: '2026-03-05T00:00:00Z',
  },
  {
    id: 'task-4',
    case_id: 'case-3',
    case_code: 'HN-GD-2026-003',
    party_name: 'Nguyễn Thị Mai Linh / Lê Hoàng Nam',
    action_type: 'decision',
    action_label: 'Dự thảo Quyết định đưa vụ án ra xét xử',
    priority: 'medium',
    due_at: '2026-03-22T17:00:00+07:00',
    created_at: '2026-03-10T00:00:00Z',
  },
  {
    id: 'task-5',
    case_id: 'case-3',
    case_code: 'HN-GD-2026-003',
    party_name: 'Nguyễn Thị Mai Linh',
    action_type: 'session',
    action_label: 'Phiên hòa giải',
    priority: 'high',
    due_at: '2026-03-20T08:00:00+07:00',
    created_at: '2026-03-08T00:00:00Z',
  },
  {
    id: 'task-6',
    case_id: 'case-4',
    case_code: 'DS-2026-004',
    party_name: 'Phạm Quốc Bảo / Lê Hoàng Nam',
    action_type: 'session',
    action_label: 'Phiên xét xử sơ thẩm',
    priority: 'urgent',
    due_at: '2026-03-18T08:00:00+07:00',
    created_at: '2026-03-01T00:00:00Z',
  },
  {
    id: 'task-7',
    case_id: 'case-5',
    case_code: 'DD-2026-005',
    party_name: 'Nguyễn Thị Mai Linh / Đặng Văn Hùng',
    action_type: 'session',
    action_label: 'Phiên họp kiểm tra chứng cứ (tranh chấp đất đai)',
    priority: 'medium',
    due_at: '2026-04-10T08:00:00+07:00',
    created_at: '2026-03-08T00:00:00Z',
  },
  {
    id: 'task-8',
    case_id: 'case-demo',
    case_code: 'HN-GD-2026-006',
    party_name: 'Phạm Thị Hồng Nhung / Trần Văn Đức',
    action_type: 'filing',
    action_label: 'Xử lý sơ bộ đơn – Kiểm tra thủ tục',
    priority: 'high',
    due_at: '2026-03-18T17:00:00+07:00',
    created_at: '2026-03-10T09:00:00Z',
  },
]
